import palette, { sidebarPalette, titlePalette } from './palette';

import { createTheme } from '@material-ui/core';
import overrides from './overrides';
import MuiDrawer from './overrides/MuiDrawer';
import typography, { baseFontFamily } from './typography';

const theme = createTheme({
  palette,
  typography: {
    ...typography,
    fontFamily: baseFontFamily,
    fontSize: 16,
  },
  overrides: {
    ...overrides,
  },
  zIndex: {
    appBar: 1200,
    drawer: 1100,
  },
});

theme.overrides.MuiTooltip.tooltip.boxShadow = theme.shadows[3];

export const sidebarTheme = createTheme({
  ...theme,
  palette: sidebarPalette,
  overrides: {
    ...overrides,
    MuiDrawer, // This removes a small white right border
  },
});

export const titleTheme = createTheme({
  ...theme,
  palette: titlePalette,
});

export default theme;
